/**
 * Nicky's Additions - 2025, 2026
 */

import Splide from '@splidejs/splide';
import { initAutocomplete } from '../search/autocomplete/autocomplete';
import { mountSRP } from '../search/srp/search-results';

document.addEventListener("DOMContentLoaded", () => {
  if (gsap) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({
      force3D: false,
    })
  }

  if (document.querySelector('#algoliaAutocomplete')) {
    initAutocomplete();
    mountSRP();
  }

  bgImageBlock();
  breadcrumbStripColor();
  dialogOpenClose();
  esgPages();
  imageRollover();
  klaviyoFormTriggers();
  mainNavigation();
  mpgCircleRotator();
  plpVideoHoverPlay();
  removeShopPayAd();
  // scrollSmoother();
  splide();
  // swiper();
  removeShopPayAd();
  roundCentlessPrices();
  timedContent();
  unitToggle();

  // allow third party script population
  let amountOfVideosOnPage = document.querySelectorAll('.mci-block-video').length;
  waitForAllElements('.able-player.able-video', amountOfVideosOnPage).then(() => {
    videoControlsToggle();
  });

});

// Re-run scoped to the reloaded section in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  bgImageBlock(event.target);
});

// --------------------------------------------------------------------------------------
// export so other modules can use these functions
export function mountSplide(el) {
  const isPaused = document.body.classList.contains('pause-anim-control__prefers-reduced-motion');

  // Destroy existing instance before re-mounting
  if (el.splideInstance) {
    el.splideInstance.destroy();
    el.splideInstance = null;
  }

  el.splideInstance = new Splide(el).mount();

  // Display current slide progress when auto-playing
  el.splideInstance.on('autoplay:playing', function (rate) {
    const timeBar = el.querySelector('.splide__pagination__page.is-active');
    const slideButtons = el.querySelectorAll('.splide__pagination__page');

    if (slideButtons.length != 0) {
      slideButtons.forEach((button) => {
        button.parentElement.classList.remove('is-active');
      });
    }

    if (timeBar) {
      timeBar.style.setProperty('--splide-progress-width', Math.round(rate * 100) + '%');
      timeBar.parentElement.classList.add('is-active');
    }
  });

  el.splideInstance.on('move', function () {
    const currentButton = el.querySelector('.splide__pagination__page.is-active');
    const otherButtons = el.querySelectorAll('.splide__pagination__page');

    if (otherButtons.length != 0) {
      otherButtons.forEach((button) => {
        button.parentElement.classList.remove('is-active');
      });
    }

    if (currentButton) {
      currentButton.parentElement.classList.add('is-active');
    }
  });

  // Respect global animation settings
  if (isPaused) {
    el.splideInstance.Components.Autoplay.pause();
  }
}

// --------------------------------------------------------------------------------------

function bgImageBlock(root = document) {
  // Assigns 'position:relative' to the parent element 
  // Only when set to block relativity vs section (--relativity-block)
  // Remove hidden attribute that was placed to remove flash of misplaced content
  const blocks = document.querySelectorAll('.mci-block-bg-image--relativity-block');

  blocks.forEach((block) => {
    let blockParent = block.parentElement;
    if (blockParent) {
      blockParent.classList.add('relative');
      block.classList.remove('hidden');
    }
  });
}

function breadcrumbStripColor() {
  // Remove the "- Colour Name" from the breadcrumbs
  let productTemplate = document.body.classList.contains('template-product');
  let breadcrumbs = document.querySelector('.breadcrumb__list--pdp');

  if (productTemplate && breadcrumbs) {
    let breadcrumbCount = breadcrumbs.children.length - 1;
    let lastBreadcrumb = breadcrumbs.children[breadcrumbCount].firstElementChild;
    let lastBreadCrumbArray = lastBreadcrumb.innerText.split(' - ');
    if (lastBreadCrumbArray.length > 2) {
      lastBreadcrumb.innerText = lastBreadCrumbArray[0] + lastBreadCrumbArray[1];
    } else {
      lastBreadcrumb.innerText = lastBreadCrumbArray[0];
    }
  }

}

function dialogOpenClose() {
  const dialog = document.querySelector("dialog");
  const showButton = document.querySelector("dialog + button");
  const closeButton = document.querySelector("dialog button");

  if (dialog) {
    // "Show the dialog" button opens the dialog modally
    showButton.addEventListener("click", () => {
      dialog.showModal();
    });

    // "Close" button closes the dialog
    closeButton.addEventListener("click", () => {
      dialog.close();
    });
  }
}

function esgPages() {
  if (window.matchMedia('screen and (min-width: 1000px)').matches) {

    let sectionBlockAnimate = document.querySelectorAll('.section-block-animate');
    let sectionBlockAnimateTrigger = document.querySelector('#animate-trigger');
    if (sectionBlockAnimate.length && sectionBlockAnimateTrigger) {
      gsap.from(sectionBlockAnimate, {
        autoAlpha: 0,
        duration: 1,
        x: '3500',
        stagger: 0.1,
        ease: 'none',
        scrollTrigger: {
          trigger: sectionBlockAnimateTrigger,
          start: 'top bottom+=25%',
          end: 'bottom center+=25%',
          scrub: 3
        }
      })
    }

    let bulletsFirst = document.querySelectorAll('ul.first-bullets li');
    let bulletsFirstTrigger = document.querySelector('.first-bullets-animation');
    if (bulletsFirst.length && bulletsFirstTrigger) {
      gsap.from(bulletsFirst, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFirstTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsSecond = document.querySelectorAll('ul.second-bullets li');
    let bulletsSecondTrigger = document.querySelector('.second-bullets-animation');
    if (bulletsSecond.length && bulletsSecondTrigger) {
      gsap.from(bulletsSecond, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsSecondTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsThird = document.querySelectorAll('ul.third-bullets li');
    let bulletsThirdTrigger = document.querySelector('.third-bullets-animation');
    if (bulletsThird.length && bulletsThirdTrigger) {
      gsap.from(bulletsThird, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsThirdTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsFourth = document.querySelectorAll('ul.fourth-bullets li');
    let bulletsFourthTrigger = document.querySelector('.fourth-bullets-animation');
    if (bulletsFourth.length && bulletsFourthTrigger) {
      gsap.from(bulletsFourth, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFourthTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
  }


  let contentAnimated = document.querySelectorAll('.content-animated');
  let contentAnimatedTrigger = document.querySelector('#animate-content');
  if (contentAnimated.length && contentAnimatedTrigger) {
    gsap.from(contentAnimated, {
      opacity: 0,
      y: -100,
      ease: 'none',
      duration: 3,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: contentAnimatedTrigger,
        start: 'top center+=50%',
        scrub: true
      }
    })
  }

  let tencelIcons = document.querySelectorAll('#tencel-icons .image-wrapper');
  let tencelIconsTrigger = document.querySelector('#tencel-icons');
  if (tencelIcons.length && tencelIconsTrigger) {
    if (window.matchMedia('screen and (min-width: 1000px)').matches) {
      gsap.from(tencelIcons, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: tencelIconsTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)

      if (window.matchMedia('screen and (max-width: 999px)').matches) {
        gsap.from(tencelIcons, {
          opacity: 0,
          x: -100,
          ease: 'back.inOut',
          stagger: 0.2,
          autoAlpha: 0,
          duration: 5,
          scrollTrigger: {
            trigger: tencelIconsTrigger,
            start: 'top center+=30%',
            end: 'bottom center+=30%',
            scrub: true
          }
        })
      }
    }
  }

  let esgChain = document.querySelectorAll('#esg-chain .image-wrapper');
  let esgChainTrigger = document.querySelector('#esg-chain');
  if (esgChain.length && esgChainTrigger) {
    if (window.matchMedia('screen and (max-width: 1099px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -100,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }

    if (window.matchMedia('screen and (min-width: 1100px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)
    }
  }

  if (window.matchMedia('screen and (min-width: 699px)').matches) {
    let tencelProcess = document.querySelectorAll('#tencel-process .image-wrapper');
    let tencelProcessTrigger = document.querySelector('#tencel-process');
    if (tencelProcess.length && tencelProcessTrigger) {
      gsap.from(tencelProcess, {
        opacity: 0,
        y: -500,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: tencelProcessTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }
  }
}

function imageRollover() {
  let rolloverBlocks = document.querySelectorAll('.mci-block-image-rollover');

  if (rolloverBlocks) {
    rolloverBlocks.forEach((block) => {
      let rolloverImage = block.querySelector('.mci-block-image-rollover__image-rollover');

      // handle focus
      block.addEventListener('focusin', () => {
        rolloverImage.classList.remove('js-mci-block-image-rollover--hidden');
        window.addEventListener("keydown", (event) => {
          if (event.key == "Escape") {
            rolloverImage.classList.add('js-mci-block-image-rollover--hidden');
          }
        });
      });
      block.addEventListener('focusout', () => {
        rolloverImage.classList.add('js-mci-block-image-rollover--hidden');
      });

      // handle hover
      // (we do this here and not CSS so we can handle the ESC key)
      block.addEventListener('mouseenter', () => {
        rolloverImage.classList.remove('js-mci-block-image-rollover--hidden');
        window.addEventListener("keydown", (event) => {
          if (event.key == "Escape") {
            rolloverImage.classList.add('js-mci-block-image-rollover--hidden');
          }
        });
      });
      block.addEventListener('mouseleave', () => {
        rolloverImage.classList.add('js-mci-block-image-rollover--hidden');
      });

    });
  }

}

function klaviyoFormTriggers() {
  let maClub = document.querySelectorAll('#klaviyo_form_trigger_ma_club');
  if (maClub.length > 0) {
    maClub.forEach(trigger => {
      trigger.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'WeAGvZ']);
      });
    });
  }
  let mondettaEmail = document.querySelectorAll('#klaviyo_form_trigger_mondetta');
  if (mondettaEmail.length > 0) {
    mondettaEmail.forEach(trigger => {
      trigger.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'V64WnG']);
      });
    });
  }
  let originalsEmail = document.querySelectorAll('#klaviyo_form_trigger_originals');
  if (originalsEmail.length > 0) {
    originalsEmail.forEach(trigger => {
      trigger.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'V64WnG']);
      });
    });
  }
  let mpgEmail = document.querySelectorAll('#klaviyo_form_trigger_mpg');
  if (mpgEmail.length > 0) {
    mpgEmail.forEach(trigger => {
      trigger.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'Uew7uz']);
      });
    });
  }
}

function mainNavigation() {
  let dropdownButtons = document.querySelectorAll('.dropdown-toggle');
  let predictiveSearchButton = document.getElementById('mainSearchToggle');
  let mobileMenuButton = document.getElementById('navToggle');
  let lastListItem = document.querySelector("#navToggle + .nav-main > li:last-of-type");



  function toggleNavMain() {
    // TODO: written this way because four clicks are triggered for some reason
    let isExpanded = mobileMenuButton.getAttribute("aria-expanded");

    if (isExpanded == "false") {
      mobileMenuButton.setAttribute("aria-expanded", "true");
    } else {
      mobileMenuButton.setAttribute("aria-expanded", "false");
    }

    document.body.classList.toggle("nav-open");
  }

  /**
   * Close navigation when certain events occur
   */
  if (predictiveSearchButton) {
    predictiveSearchButton.addEventListener("click", () => {
      if (mobileMenuButton.getAttribute("aria-expanded") == "true") {
        toggleNavMain();
      }
    });
  }
  /**
   * Main mobile navigation toggle
   */
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener("click", () => {
      toggleNavMain();
    });
  }

  /**
   * Closes mobile navigation once you're through all of the list items
   */
  if (lastListItem) {
    lastListItem.addEventListener("focusout", () => {
      if (mobileMenuButton.getAttribute("aria-expanded") == "true") {
        toggleNavMain();
      }
    });
  }

  if (dropdownButtons) {
    /**
     * FUNCTION
     * Close all open dropdowns
     */
    function closeAllDropDowns() {
      dropdownButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    }

    /**
     * FUNCTION
     * Toggle dropdown open/close
     */
    function toggleDropdown(event, button) {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      closeAllDropDowns();

      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
      }
    }

    /**
     * FUNCTION
     * Close dropdown when clicking outside
     * - Does not work at the moment
     */
    function closeOnBlur(button, options = {}) {
      document.addEventListener("click", (event) => {
        if (
          event.target.parentElement.classList.contains("js-mci-nav-link") ||
          event.target.parentElement.classList.contains("nav-main__primary") ||
          event.target.parentElement.classList.contains("nav-main__primary__submenu")
        ) {
          // do nothing
        } else {
          closeAllDropDowns();
          document.body.classList.remove("nav-open");
        }
      });
    }

    /**
     * FUNCTION
     * Closes dropdowns when tabbing out of them
     */
    function handleFocus(button) {
      const subMenuListElement = button.nextElementSibling;

      if (subMenuListElement) {
        button.addEventListener("focusout", (event) => {
          event.stopImmediatePropagation();
        });

        subMenuListElement.addEventListener("focusout", (event) => {
          const nextFocusElement = event.relatedTarget;

          const isSubMenuElement =
            nextFocusElement &&
            nextFocusElement.classList.contains("button") ||
            nextFocusElement.classList.contains("link") ||
            nextFocusElement.classList.contains("js-mci-nav-link");

          if (!isSubMenuElement) {
            closeAllDropDowns();
          }
        });
      }
    }

    /**
     * EVENT
     * Adds event listeners to dropdown buttons (desktop)
     */

    dropdownButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        toggleDropdown(event, button);
      });

      closeOnBlur(button);
      handleFocus(button);
    });

    /**
     * EVENT
     * Closes menu on escape key
     */
    window.addEventListener("keydown", (event) => {
      if (event.key == "Escape") {
        document.body.classList.remove("nav-open");
        closeAllDropDowns();
        if (mobileMenuButton.getAttribute("aria-expanded") == "true") {
          toggleNavMain();
        }
      }
    });
  }
}

function mpgCircleRotator() {
  // Scripts required to make the MPG Circle Rotating Text block work

  const rotator = document.querySelector('.rotator');
  const playPause = document.querySelector('.mci-section-mpg-circle-rotating-text .mci-playpause-button');

  if (rotator) {
    let animation = gsap.timeline({ repeat: 20 });
    let targets = document.querySelectorAll('.rotator span');
    let numberOfTargets = targets.length;

    let duration = 0.6;
    let pause = 2;

    let stagger = duration + pause;
    let repeatDelay = stagger * (numberOfTargets - 1) + pause;

    function init() {
      gsap.set('.rotator', { autoAlpha: 1 });
      animation
        .from(targets, {
          y: 80,
          duration: duration,
          opacity: 0,
          ease: 'power2.out',
          stagger: {
            each: stagger,
            repeat: -1,
            repeatDelay: repeatDelay,
          },
        })
        .to(
          targets,
          {
            y: -80,
            duration: duration,
            opacity: 0,
            ease: 'power2.out',
            stagger: {
              each: stagger,
              repeat: -1,
              repeatDelay: repeatDelay,
            },
          },
          stagger
        );
    }
    // play/pause
    playPause.addEventListener('click', () => {
      animation.paused(!animation.paused());
      if (playPause.getAttribute('aria-label') == 'Pause') {
        playPause.setAttribute('aria-label', 'Play');
      } else {
        playPause.setAttribute('aria-label', 'Pause');
      }
    });

    init();
  }
}

function plpVideoHoverPlay() {
  let plpVideos = document.querySelectorAll('.product-card__media video');

  if (plpVideos.length != 0) {
    plpVideos.forEach((video) => {
      let videoCover = video.parentElement.querySelector('img');
      video.style.opacity = 1;

      video.parentElement.addEventListener('mouseover', (event) => {
        video.play();
        videoCover.style.opacity = 0;
      });

      video.parentElement.addEventListener('mouseout', (event) => {
        video.pause();
        videoCover.style.opacity = 1;
      });
    });
  }
}

function removeShopPayAd() {
  let multiPackProduct = document.querySelector('.product--same-color, .product--different-color');
  let shopPayAd = document.querySelector('div[data-block-type="payment-terms"]');
  if (multiPackProduct) {
    shopPayAd.hidden = true;
  }
}

function roundCentlessPrices() {
  if (document.body.classList.contains('js-mci-round-centless-prices')) {
    let priceArray = document.querySelectorAll('sale-price');
    let compareAtArray = document.querySelectorAll('compare-at-price');

    priceArray.forEach(price => {
      if (price.innerHTML.includes(".00")) {
        price.innerHTML = price.innerHTML.replace(".00", "");
      }
    });

    compareAtArray.forEach(price => {
      if (price.innerHTML.includes(".00")) {
        price.innerHTML = price.innerHTML.replace(".00", "");
      }
    });
  }
}

function scrollSmoother() {
  gsap.registerPlugin(ScrollSmoother);

  if (ScrollSmoother) {
    // init
    ScrollSmoother.create({
      smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true, // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });

    // fix sticky stuff on PDP
    ScrollTrigger.create({
      trigger: "safe-sticky",
      start: "top",
      endTrigger: "scroll-carousel",
      end: "bottom bottom",
      pin: true,
      scrub: 1,
    });

  }

}

function splide() {


  function initSplide() {
    document.querySelectorAll('.splide').forEach(mountSplide);
  }

  // Initial page load
  initSplide();

  // Re-init when theme editor reloads a section
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.splide').forEach(mountSplide);
  });

  // Clean up on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.splide').forEach((el) => {
      if (el.splideInstance) {
        el.splideInstance.destroy();
        el.splideInstance = null;
      }
    });
  });

  // Jump to the selected slide when a block is clicked in the editor sidebar
  document.addEventListener('shopify:block:select', (event) => {
    const splideEl = event.target.closest('.splide');
    if (!splideEl?.splideInstance) return;

    const slideIndex = [...splideEl.querySelectorAll('.splide__slide')].indexOf(event.target);
    if (slideIndex > -1) {
      splideEl.splideInstance.go(slideIndex);
    }
  });
}

function swiper() {
  let checkForSwiper = document.querySelector('.swiper');
  if (checkForSwiper) {
    new Swiper('.swiper', {
      // Optional parameters
      a11y: true,
      direction: 'vertical',
      loop: false,
      parallax: true,
      speed: 800,
      oneWayMovement: true,

      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      scrollbar: {
        snapOnRelease: true,
      },

      accessibility: {
        enabled: true,
      },

      keyboard: {
        enabled: true,
      },

      virtual: {
        enabled: true,
        addSlidesAfter: 1,
      },

      mousewheel: {
        enabled: true,
        sensitivity: 0.005,
        // releaseOnEdges: true,
        thresholdDelta: 15,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: true,
      },
    });
  }

}

function timedContent() {
  // Show hide content with the class "js-timed" based on the set show and hide time
  // Uses HTML 'hidden' attribute

  let timedContent = document.querySelectorAll('.js-timed');

  if (timedContent) {
    let now = Date.now();

    timedContent.forEach((item) => {
      let showTime = parseInt(item.dataset.timedStart);
      let hideTime = parseInt(item.dataset.timedEnd);

      if (now >= showTime && now <= hideTime) {
        item.hidden = false;
      }

    });
  }
}

function unitToggle() {
  let inButton = document.querySelector("#mciUnitToggleIN");
  let cmButton = document.querySelector("#mciUnitToggleCM");
  let measurementTables = document.querySelectorAll(".mci-measurement-table");

  if (measurementTables && inButton && cmButton) {
    inButton.addEventListener('click', function () {
      inButton.setAttribute("aria-pressed", "true");
      cmButton.setAttribute("aria-pressed", "false");
      measurementTables.forEach((table) => {
        table.classList.add('mci-measurement-table--in');
        table.classList.remove('mci-measurement-table--cm');
      })
    });

    cmButton.addEventListener('click', function () {
      cmButton.setAttribute("aria-pressed", "true");
      inButton.setAttribute("aria-pressed", "false");
      measurementTables.forEach((table) => {
        table.classList.add('mci-measurement-table--cm');
        table.classList.remove('mci-measurement-table--in');
      })
    });
  }

}

function videoControlsToggle() {
  let videoHeroes = document.querySelectorAll('.mci-block-video-hero');
  let videoControls = document.querySelectorAll('.able-player.able-video');

  if (videoHeroes) {
    videoHeroes.forEach((hero) => {
      let videoControlsButton = hero.querySelector('.mci-block-video-hero__controls button');
      let videoControls = hero.querySelector('.able-player.able-video');

      if (videoControls) {
        videoControlsButton.addEventListener('click', function () {
          videoControls.classList.toggle('fade-in');
          videoControls.classList.toggle('fade-out');
        })
      }

    });
  }

  if (videoControls) {
    videoControls.forEach((controlBar) => {
      // dynamically set the margin offset of the controlbar to acommodate different 
      // button sizes and margins for mobile, etc.
      let height = controlBar.clientHeight;
      controlBar.style.marginTop = "-" + height + "px";
    });
  }
}


// Utility Functions
function waitForAllElements(selector, expectedCount) {
  return new Promise(resolve => {
    const elements = document.querySelectorAll(selector);
    if (elements.length >= expectedCount) {
      return resolve(elements);
    }

    const observer = new MutationObserver(mutations => {
      const updatedElements = document.querySelectorAll(selector);
      if (updatedElements.length >= expectedCount) {
        observer.disconnect();
        resolve(updatedElements);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}


function waitForElement(selector) {
  return new Promise((resolve) => {
    const observer = new MutationObserver((mutations, observer) => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}